import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4","key":"svg-0"}],["path",{"d":"M10 14v-4a2 2 0 1 1 4 0v4","key":"svg-1"}],["path",{"d":"M14 12h-4","key":"svg-2"}]]

const IconMessageLanguage = createReactComponent('outline', 'message-language', 'MessageLanguage', __iconNode);

export default IconMessageLanguage;